import React from "react";
import thinking from "../Image/underp.png";
import { useNavigate } from "react-router-dom";
import { Wave } from 'react-animated-text';
const Sorry = () => {
          let navigate = useNavigate();
  const onButtonClick = () => {
          navigate("/");
  };
  return (
    <center>
      <div className="mt-[84px]">
        <div className="flex items-center justify-center   ">
          <img
            src={thinking}
            alt=""
            className="w-[400px] md:w-[400px]  "
          />
        </div>
  
        <div className="flex  flex-col items-center justify-center ">
          <p
            className=" dark:text-white mt-4 text-[24px] md:text-[44px] "
          
          >
            Thanku for showing intrest.
          </p>
          <p
            className="text-[#17A6DB] dark:text-[#30dada] pl-2 pb-2 md:pb-8 text-[20px] md:text-[44px] "
            
          >
             <Wave
              text="I am working on blogs."
              effect="stretch"
              effectChange="2"
            />
           
          </p>
          <button
            onClick={onButtonClick}
            className="py-3 px-14 flex text-lg font-normal dark:text-white  border-[4px] border-[#17A6DB] dark:border-[#30dada] rounded-[48px] shadow-[40px] duration-200  hover:dark:text-white  md:text-3xl"
          >
            Go Back
          </button>
        </div>
      </div>
    </center>
  );
};

export default Sorry;
